import axios from "axios";
import map from "lodash/map";
import moment from "moment";
import { browserHistory } from "react-router";
import { SubmissionError } from "redux-form";
import {
  toFromDates,
  convertUtcDate,
  getFromToDates,
} from "../components/Common/cleanDates";

import {
  REQUEST_ROUTES,
  FETCH_ROUTES_SUCCESS,
  FETCH_ROUTES_FAILURE,
  REQUEST_ALL_ROUTES,
  FETCH_ALL_ROUTES_SUCCESS,
  FETCH_ALL_ROUTES_FAILURE,
  REQUEST_STOPS,
  FETCH_STOPS_SUCCESS,
  FETCH_STOPS_FAILURE,
  REQUEST_EDIT_STOPS,
  FETCH_EDIT_STOPS_SUCCESS,
  FETCH_EDIT_STOPS_FAILURE,
  REQUEST_SAVE_EDITS,
  SAVE_EDITS_SUCCESS,
  SAVE_EDITS_FAILURE,
  CLEAR_EDIT_STATUS,
  REQUEST_SALES_ORDERS_BY_DATE,
  FETCH_SALES_ORDERS_BY_DATE_SUCCESS,
  FETCH_SALES_ORDERS_BY_DATE_FAILURE,
  REQUEST_CUSTOMER_ROUTES,
  FETCH_CUSTOMER_ROUTES_SUCCESS,
  FETCH_CUSTOMER_ROUTES_FAILURE,
  REQUEST_UNASSIGNED_ORDERS,
  FETCH_UNASSIGNED_ORDERS_SUCCESS,
  FETCH_UNASSIGNED_ORDERS_FAILURE,
  REQUEST_ASSIGN_ORDER_ROUTE,
  ASSIGN_ORDER_ROUTE_SUCCESS,
  ASSIGN_ORDER_ROUTE_FAILURE,
  REQUEST_SAVE_ROUTE_EDITS,
  SAVE_ROUTE_EDIT_SUCCESS,
  SAVE_ROUTE_EDIT_FAILURE,
  REQUEST_CONVERT_TO_INVOICE,
  CONVERT_TO_INVOICE_SUCCESS,
  CONVERT_TO_INVOICE_FAILURE,
  CLEAR_CONVERT_TO_INVOICE,
  CONVERT_TO_INVOICE_RESET,
  SAVE_EDITED_STOPS,
  SAVE_EDITED_STOPS_SUCCESS,
  SAVE_EDITED_STOPS_FAILURE,
  REQUEST_SAVE_NEW_ROUTES,
  SAVE_NEW_ROUTES_SUCCESS,
  SAVE_NEW_ROUTES_FAILURE,
  FETCH_ROUTES_PRINTER_SUCESS,
  SAVE_ROUTES_PRINTER_SUCESS,
  SET_AUTO_ROUTING_BUTTONS_LOADING,
  FETCH_AUTO_ROUTES_SUCCESS,
  START_FETCHING_AUTO_ROUTES,
  SELECT_DRIVER,
  RESET_CURRENT_DRIVER,
  CREATE_DRIVER_SUCCESS,
  CREATE_DRIVER_FAILURE,
  EDIT_DRIVER_SUCCESS,
  EDIT_DRIVER_FAILURE,
  RESET_CREATE_DRIVER,
  RESET_EDIT_DRIVER,
} from "./type";

import {
  DISPATCH_URL,
  DISPATCH_DELIVERY_FEE_URL,
  OUTGOING_ORDERS_BY_DATE_URL,
  SALES_INVOICE_URL,
  RELEASE_SALES_ORDER_URL,
  BASE_USER_URL,
  ROUTES_PRINTER_TIME,
} from "./url";

import {
  ROOT_API_URL, ROOT_URL, isLE, isGGI, isSUN, isLMH, isBRO, isSDR, isCRW, isSC
} from "./root_url";

const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";

import { DEFAULT_ERROR } from "../components/Common/constants";
import { getLocalStorageData } from '../reducers/headerRedux';

const form = "AutoRouting";

export const generateRoute = (
  {
    startDateGenerate,
    endDateGenerate,
    MaxTotalHours,
    RouteCounts,
    ServiceMinutes,
    IsForenoon,
  },
  success,
  fail
) => (dispatch) => {
  dispatch(setButtonsLoading(true));
  const { fromDate, toDate } = toFromDates(
    -1,
    startDateGenerate,
    endDateGenerate
  );
  const payload = {
    StartDeliveryDate: fromDate,
    EndDeliveryDate: toDate,
    MaxTotalHours,
    RouteCounts,
    ServiceMinutes,
    IsForenoon,
  };
  return axios({
    method: "POST",
    data: payload,
    url: `${DISPATCH_URL}optimizer-route`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(
    (response) => {
      dispatch(setButtonsLoading(false));
      success();
    },
    (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        fail();
        alert(err.data);
        dispatch(setButtonsLoading(false));
      }
    }
  );
};

export function requestRoutes() {
  return { type: REQUEST_ROUTES };
}
export function fetchRoutesSuccess(routes) {
  return {
    type: FETCH_ROUTES_SUCCESS,
    payload: routes,
  };
}
export function fetchRoutesFailure(error) {
  return {
    type: FETCH_ROUTES_FAILURE,
    payload: error,
  };
}
export function fetchRoutes(date) {
  let dateParam;
  if (!date) {
    dateParam = "";
  } else {
    const { fromDate, toDate } = getFromToDates(date);
    dateParam = `?StartDate=${fromDate}&EndDate=${toDate}`;
  }
  return (dispatch) => {
    dispatch(requestRoutes());
    return axios({
      method: "get",
      url: `${DISPATCH_URL}route/${dateParam}`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(
      (response) => {
        dispatch(fetchRoutesSuccess(response));
      },
      (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchRoutesFailure(err));
        }
      }
    );
  };
}

// all routes iting
export function requestAllRoutes() {
  return { type: REQUEST_ALL_ROUTES };
}
export function fetchAllRoutesSuccess(routes) {
  return {
    type: FETCH_ALL_ROUTES_SUCCESS,
    payload: routes,
  };
}
export function fetchAllRoutesFailure(error) {
  return {
    type: FETCH_ALL_ROUTES_FAILURE,
    payload: error,
  };
}
export function fetchAllRoutes2(date) {
  return (dispatch) => {
    dispatch(requestAllRoutes());
    return axios({
      method: "get",
      url: `${DISPATCH_URL}all-route`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(
      (response) => {
        dispatch(fetchAllRoutesSuccess(response));
      },
      (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchAllRoutesFailure(err));
        }
      }
    );
  };
}

// all routes
export const fetchAllRoutes = () => dispatch => {
  axios({
    method: 'GET',
    url: `${DISPATCH_URL}all-route`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(res => {
    dispatch({
      type: 'ALL_ROUTES',
      payload: res.data,
    })
  })
}

export const fetchSelectedRouteDispatchId = (Day, RouteName, success) => dispatch => {
  axios({
    method: 'GET',
    url: `${DISPATCH_URL}dispatch-route`,
    params: {
      Day, RouteName,
    },
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(res => {
    success(res.data.DispatchRoute_id);
  }).catch(res => {
    success(null);
  })
}

export function fetchAutoRoutesSuccess(autoRoutes) {
  return {
    type: FETCH_AUTO_ROUTES_SUCCESS,
    payload: autoRoutes,
  };
}
function startFetchingAutoRoutes() {
  return {
    type: START_FETCHING_AUTO_ROUTES,
  };
}
export const fetchAutoRoutes = (fromDate, toDate) => (dispatch) => {
  dispatch(startFetchingAutoRoutes());
  return axios({
    method: "GET",
    // data: payload,
    url: `${DISPATCH_URL}optimizer-route-list/?StartDeliveryDate=${fromDate}&EndDeliveryDate=${toDate}`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(
    (response) => {
      dispatch(fetchAutoRoutesSuccess(response));
    },
    (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      }
    }
  );
};

function fetchRoutesPrinterSuccess(data) {
  return {
    type: FETCH_ROUTES_PRINTER_SUCESS,
    payload: data,
  };
}
export function fetchRoutesPrinter() {
  return (dispatch) =>
    axios({
      method: "GET",
      url: `${ROUTES_PRINTER_TIME}`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
    .then((res) => {
      dispatch(fetchRoutesPrinterSuccess(res.data));
    })
    .catch((err) => {
      console.log("err fetching routes printer time", err);
    });
}

function setButtonsLoading(value) {
  return {
    type: SET_AUTO_ROUTING_BUTTONS_LOADING,
    payload: value,
  };
}


export const changeFormValue = (change, field, value) => (dispatch) => {
  dispatch(change(form, field, value));
};

export function saveRoutesPrinterSuccess(bool) {
  return {
    type: SAVE_ROUTES_PRINTER_SUCESS,
    payload: bool,
  };
}
export function saveRoutesPrinter(data) {
  return (dispatch) => {
    dispatch(saveRoutesPrinterSuccess(false));
    axios({
      method: "PUT",
      url: `${ROUTES_PRINTER_TIME}`,
      data,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then(() => {
        dispatch(saveRoutesPrinterSuccess(true));
      })
      .catch((err) => {
        console.log("err fetching routes printer time", err);
      });
  };
}

export const fetchAutoRouteStops = (RouteId) => (dispatch) => {
  // const {
  //   fromDate,
  //   toDate,
  // } = toFromDates(-1, StartDeliveryDate, EndDeliveryDate);
  if (!RouteId) {
    dispatch(
      fetchStopsSuccess({
        data: [],
      })
    );
    return;
  }
  axios({
    method: "GET",
    // data: payload,
    url: `${DISPATCH_URL}optimizer-route-list/${RouteId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(
    (response) => {
      dispatch(fetchStopsSuccess(response));
    },
    (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      }
      // if (err.status === 500 || err.status === 404) {
      //   err.data = DEFAULT_ERROR;
      // }
      // dispatch(fetchRoutesFailure(err));
    }
  );
};

export const updateStopsOfAutoRoutes = ({
  routeId,
  method,
  data,
  callback = () => {},
}) => (dispatch) => {
  axios({
    method: "PUT",
    data,
    url: `${DISPATCH_URL}update-route-stop/${routeId}/${method}`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(
    (response) => {
      dispatch(fetchStopsSuccess(response));
      callback();
    },
    (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      }
      // if (err.status === 500 || err.status === 404) {
      //   err.data = DEFAULT_ERROR;
      // }
      // dispatch(fetchRoutesFailure(err));
    }
  );
};

export const changeStopIndex = (data, success) => dispatch => {
  axios({
    method: "PUT",
    data,
    url: `${DISPATCH_URL}update-route-stop-index`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(
    (response) => {
      success();
    },
    (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert('error updating stop index');
      }
    }
  );
}

export function requestStops() {
  return {
    type: REQUEST_STOPS,
  };
}

export function fetchStopsSuccess(stops) {
  return {
    type: FETCH_STOPS_SUCCESS,
    payload: stops,
  };
}

export function fetchStopsFailure(error) {
  return {
    type: FETCH_STOPS_FAILURE,
    payload: error,
  };
}

export function fetchStops(routeNum, date, warehouse) {
  const { fromDate, toDate } = getFromToDates(date);

  let warehouse_id = ``;
  if ( (isSUN || isLMH || isBRO || isSDR || isCRW || isSC) && warehouse){
    warehouse_id = `&warehouse_id=${warehouse}`;
  }

  return (dispatch) => {
    dispatch(requestStops());
    return axios
      .get(
        `${DISPATCH_URL}stop/${routeNum}?StartDate=${fromDate}&EndDate=${toDate}${warehouse_id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then(
        (response) => {
          dispatch(fetchStopsSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(fetchStopsFailure(err));
          }
        }
      );
  };
}

export function requestSaveNewRoute() {
  return {
    type: REQUEST_SAVE_NEW_ROUTES,
  };
}

export function saveNewRouteSuccess(routes) {
  return {
    type: SAVE_NEW_ROUTES_SUCCESS,
    payload: routes,
  };
}

export function saveNewRouteFailure(error) {
  return {
    type: SAVE_NEW_ROUTES_FAILURE,
    payload: error,
  };
}

export function saveNewRoute(data, callback) {
  return (dispatch) => {
    dispatch(requestRoutes());
    let url = '';
    if (isLE) {
      url = `${DISPATCH_URL}add-route`
    } else {
      url = `${DISPATCH_URL}route/`
    }
    return axios
      .post(
        url,
        {
          ...data,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then(
        (response) => {
          Promise.resolve(dispatch(saveNewRouteSuccess(response))).then(() =>
            callback()
          );
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(saveNewRouteFailure(err));
          }
        }
      );
  };
}

export function requestSaveEditedStops() {
  return {
    type: SAVE_EDITED_STOPS,
  };
}

export function saveEditedStopsSuccess(stops) {
  return {
    type: SAVE_EDITED_STOPS_SUCCESS,
    payload: stops,
  };
}

export function saveEditedStopsFailure(error) {
  return {
    type: SAVE_EDITED_STOPS_FAILURE,
    payload: error,
  };
}

export function saveEditedStops(Stops, date, DispatchRouteId) {
  const { fromDate, toDate } = getFromToDates(date);
  return (dispatch) => {
    dispatch(requestSaveEditedStops());
    return axios
      .put(
        `${DISPATCH_URL}stop/?StartDate=${fromDate}&EndDate=${toDate}`,
        {
          DispatchRouteId,
          Stops,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then(
        (response) => {
          dispatch(saveEditedStopsSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(saveEditedStopsFailure(err));
          }
        }
      );
  };
}

export function fetchEditStops(date, Route_id) {
  return (dispatch) => {
    dispatch(requestEditStops());
    return axios
      .get(DISPATCH_URL + "stop/" + convertUtcDate(date) + "/" + Route_id, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then(
        (response) => {
          dispatch(fetchEditStopsSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(fetchEditStopsFailure(err));
          }
        }
      );
  };
}

export function requestEditStops() {
  return {
    type: REQUEST_EDIT_STOPS,
  };
}

export function fetchEditStopsSuccess(stops) {
  return {
    type: FETCH_EDIT_STOPS_SUCCESS,
    payload: stops,
  };
}

export function fetchEditStopsFailure(error) {
  return {
    type: FETCH_EDIT_STOPS_FAILURE,
    payload: error,
  };
}

export function saveEdits({ TempDate, TempDispatchRoute_id, Stops }) {
  TempDate = TempDate ? convertUtcDate(TempDate) : "";
  return (dispatch) => {
    dispatch(requestSaveEdits());
    return axios
      .put(
        DISPATCH_URL + "stop/",
        {
          TempDate,
          TempDispatchRoute_id,
          Stops,
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then(
        (response) => {
          dispatch(saveEditsSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(saveEditsFailure(err));
          }
        }
      );
  };
}

export function requestSaveEdits() {
  return {
    type: REQUEST_SAVE_EDITS,
  };
}

export function saveEditsSuccess() {
  return {
    type: SAVE_EDITS_SUCCESS,
  };
}

export function saveEditsFailure(error) {
  return {
    type: SAVE_EDITS_FAILURE,
    payload: error,
  };
}

export function clearEditStatus() {
  return {
    type: CLEAR_EDIT_STATUS,
  };
}

export function fetchSalesOrdersByDate({ fromDate, toDate }) {
  return (dispatch) => {
    dispatch(requestSalesOrdersByDate());
    const dates = toFromDates(-1, fromDate, toDate);
    const activeCompany = getLocalStorageData('selectedCompany');
    const activeWarehouse =  getLocalStorageData('selectedWarehouse');
    return axios({
      method: "get",
      url: OUTGOING_ORDERS_BY_DATE_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      params: {
        start_date: dates.fromDate,
        end_date: dates.toDate,
        companyId: activeCompany.value,
        warehouseId: activeWarehouse.value,
      },
    }).then(
      (response) => {
        dispatch(fetchSalesOrdersByDateSuccess(response));
      },
      (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSalesOrdersByDateFailure(err));
        }
      }
    );
  };
}

export function requestSalesOrdersByDate() {
  return {
    type: REQUEST_SALES_ORDERS_BY_DATE,
  };
}

export function fetchSalesOrdersByDateSuccess(orders) {
  return {
    type: FETCH_SALES_ORDERS_BY_DATE_SUCCESS,
    payload: orders,
  };
}

export function fetchSalesOrdersByDateFailure(error) {
  return {
    type: FETCH_SALES_ORDERS_BY_DATE_FAILURE,
    payload: error,
  };
}

export function requestCustomerRoutes() {
  return {
    type: REQUEST_CUSTOMER_ROUTES,
  };
}

export function fetchCustomerRoutesSuccess(routes) {
  return {
    type: FETCH_CUSTOMER_ROUTES_SUCCESS,
    payload: routes,
  };
}

export function fetchCustomerRoutesFailure(error) {
  return {
    type: FETCH_CUSTOMER_ROUTES_FAILURE,
    payload: error,
  };
}

export function fetchCustomerRoutes(day) {
  const dayString = day === "All" ? "" : `?Day=${day}`;
  return (dispatch) => {
    dispatch(requestCustomerRoutes());
    return axios
      .get(`${DISPATCH_URL}customers/${dayString}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then(
        (response) => {
          dispatch(fetchCustomerRoutesSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(fetchCustomerRoutesFailure(err));
          }
        }
      );
  };
}

export function fetchUnassignedOrders(date) {
  const { fromDate, toDate } = getFromToDates(date);
  let belongWarehouse = ``;
  if (
    !localStorage.getItem("warehouseLocation") ||
    localStorage.getItem("warehouseLocation") === ""
  ) {
    belongWarehouse = ``;
  } else {
    belongWarehouse = `&BelongWarehouse=${localStorage.getItem(
      "warehouseLocation"
    )}`;
  }
  return (dispatch) => {
    dispatch(requestUnassignedOrders());
    return axios
      .get(
        `${DISPATCH_URL}orders/?StartDate=${fromDate}&EndDate=${toDate}${belongWarehouse}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then(
        (response) => {
          dispatch(fetchUnassignedOrdersSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(fetchUnassignedOrdersFailure(err));
          }
        }
      );
  };
}

export function requestUnassignedOrders() {
  return {
    type: REQUEST_UNASSIGNED_ORDERS,
  };
}

export function fetchUnassignedOrdersSuccess(orders) {
  return {
    type: FETCH_UNASSIGNED_ORDERS_SUCCESS,
    payload: orders,
  };
}

export function fetchUnassignedOrdersFailure(error) {
  return {
    type: FETCH_UNASSIGNED_ORDERS_FAILURE,
    payload: error,
  };
}

export function requestAssignOrderRoute() {
  return {
    type: REQUEST_ASSIGN_ORDER_ROUTE,
  };
}

export function assignOrderRouteSuccess() {
  return {
    type: ASSIGN_ORDER_ROUTE_SUCCESS,
  };
}

export function assignOrderRouteFailure(error) {
  return {
    type: ASSIGN_ORDER_ROUTE_FAILURE,
    payload: error,
  };
}

export function assignOrderRoute(orders) {
  return (dispatch) => {
    dispatch(requestAssignOrderRoute());
    return axios
      .post(
        `${DISPATCH_URL}stop/`,
        {
          orders,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      )
      .then(
        (response) => {
          dispatch(assignOrderRouteSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(assignOrderRouteFailure(err));
          }
        }
      );
  };
}

export function requestRouteEdits() {
  return {
    type: REQUEST_SAVE_ROUTE_EDITS,
  };
}

export function saveRouteEditsSuccessful() {
  return {
    type: SAVE_ROUTE_EDIT_SUCCESS,
  };
}

export function saveRouteEditsFailure(error) {
  return {
    type: SAVE_ROUTE_EDIT_FAILURE,
    payload: error,
  };
}

export function saveRouteEdits(OldRoute, NewRoute, email, driverId) {
  return (dispatch) => {
    dispatch(requestRouteEdits());
    return axios({
      method: "put",
      url: `${DISPATCH_URL}customers/`,
      data: {
        OldRoute,
        NewRoute,
        Email: email,
        driver_id: driverId,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(
      (response) => {
        dispatch(saveRouteEditsSuccessful(response));
      },
      (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(saveRouteEditsFailure(err));
        }
      }
    );
  };
}

export function convertToInvoice(
  pk,
  lines,
  PaymentType,
  PaymentNum,
  partialParams,
  InvoiceShipDate,
  isMergeSo,
  mergeSoIds,
  shipment_info,
  PostingDate,
) {
  if (!PaymentType) {
    PaymentType = "Not Paid";
  }
  if (isMergeSo) {
    return dispatch => {
      dispatch(requestConvertToInvoice());
      const url = `${ROOT_URL}v1/sale/merge_sales_invoice/${mergeSoIds}`;
      return axios
        .post(
          url,
          {
            Sales_Order_Lines: lines,
            PaymentType,
            PaymentNum,
            InvoiceShipDate,
            shipment_info,
            PostingDate,
          },
          {
            headers: { Authorization: "Bearer " + localStorage.getItem("token") },
          }
        )
        .then(
          (response) => {
            dispatch(convertToInvoiceSuccess(response));
          },
          (err) => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(convertToInvoiceFailure(err));
            }
          }
        );
    }
  }

  return (dispatch) => {
    dispatch(requestConvertToInvoice());
    // const type = isPartial ? "partial" : "completed";
    const url = !isABC
      ? `${RELEASE_SALES_ORDER_URL}${pk}/`
      : `${RELEASE_SALES_ORDER_URL}${pk}/${type}`;
    return axios
      .post(
        url,
        {
          Sales_Order_Lines: lines,
          PaymentType,
          PaymentNum,
          InvoiceShipDate,
          shipment_info,
          PostingDate,
          ...partialParams,
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then(
        (response) => {
          dispatch(convertToInvoiceSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(convertToInvoiceFailure(err));
          }
        }
      );
  };
}

export function requestConvertToInvoice() {
  return {
    type: REQUEST_CONVERT_TO_INVOICE,
  };
}

export function convertToInvoiceSuccess(invoice) {
  return {
    type: CONVERT_TO_INVOICE_SUCCESS,
    payload: invoice,
  };
}

export function convertToInvoiceFailure(error) {
  return {
    type: CONVERT_TO_INVOICE_FAILURE,
    payload: error,
  };
}

export function clearConvertingToInvoice() {
  return {
    type: CLEAR_CONVERT_TO_INVOICE,
  };
}

export function convertingToInvoiceReset() {
  return {
    type: CONVERT_TO_INVOICE_RESET,
  };
}

const salesOrderShape = (data = []) =>
  map(data, (obj) => ({
    soNum: obj.SONum,
    shipmentDate: obj.ShipmentDate,
    driverFee: obj.driver_fee,
    truckxiFee: obj.truckxi_fee,
    totalDeliveryFee: obj.total_delivery_fee,
  }));

const desiredDriversShape = (data = []) =>
  map(data, (obj) => ({
    driverLicenseNumber: obj.driver_license_number,
    email: obj.email,
    name: `${obj.first_name} ${obj.last_name}`,
    first_name: obj.first_name,
    last_name: obj.last_name,
    username: obj.username,
    // password: obj.password,
    short_name: obj.short_name,
    id: obj.id,
    isActive: obj.is_active,
    isExternalWorker: obj.is_external_worker,
    licensePlate: obj.license_plate,
    phone: obj.phone,
    userId: obj.user_id,
    salesOrders: salesOrderShape(obj.sales_orders),
  }));

export function fetchDrivers(startDate, endDate, handleSuccess, handleFailure, companyId) {
  const { fromDate, toDate } = toFromDates(-1, startDate, endDate);
  const config = {
    method: "get",
    url: `${BASE_USER_URL}driver/`,
    params: {
      sales_orders__ShipmentDate__gte: fromDate,
      sales_orders__ShipmentDate__let: toDate,
      ...(companyId ? {Company_id: companyId} : {})
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  axios(config).then(
    (response) => {
      handleSuccess(desiredDriversShape(response.data));
    },
    (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    }
  );
}

export function selectDriver(driver) {
  return {
    type: SELECT_DRIVER,
    payload: driver,
  };
}

export function resetCurrentDriver() {
  return {
    type: RESET_CURRENT_DRIVER,
  }
}

export function createDriver({ username, email, first_name, last_name, short_name, password }) {
  return dispatch => {
    axios.post(
      `${BASE_USER_URL}driver-sign-up`,
      { username, email, first_name, last_name, short_name, password },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      }
    )
    .then(response => {
      dispatch({ type: CREATE_DRIVER_SUCCESS });
      browserHistory.push('/drivers');
    }, err => {
      const data = err.data;
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch({ type: CREATE_DRIVER_FAILURE, payload: err });
      }
      throw new SubmissionError(data);
    });
  }
}

export function editDriver({ id, username, email, first_name, last_name, short_name, password }) {
  return dispatch => {
    axios.put(
      `${BASE_USER_URL}update_driver_info/${id}`,
      { username, email, first_name, last_name, short_name, password },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      }
    )
    .then(response => {
      dispatch({ type: EDIT_DRIVER_SUCCESS });
      browserHistory.push('/drivers');
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch({ type: EDIT_DRIVER_FAILURE, payload: err });
      }
    });
  }
}

export function resetCreateDriver() {
  return {
    type: RESET_CREATE_DRIVER,
  }
}

export function resetEditDriver() {
  return {
    type: RESET_EDIT_DRIVER,
  }
}

export const printPickinglist = (routeId) => dispatch => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/sale/printpickinglistnew/${routeId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: 'blob',
  }).then(res => {
    dispatch({
      type: 'AUTO_ROUTING/routePickingList',
      payload: res.data,
    })
  }, err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert('err on deleting selected route', err);
    }
  });
}

export const printPickinglistAll = (routeId) => dispatch => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/sale/printpickingliststop/${routeId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: 'blob',
  }).then(res => {
    dispatch({
      type: 'AUTO_ROUTING/routePickingList',
      payload: res.data,
    })
  }, err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert('err on deleting selected route', err);
    }
  });
}

export const deleteRoute = (routeId, success) => {
  // success();
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/dispatch/optimizer-route/${routeId}`,
  }).then(res => {
    success();
  }, err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert('err on deleting selected route', err);
    }
  });
};

export const assignDriverToRoute = (data, success, fail) => {
  const config = {
    method: "POST",
    url: `${DISPATCH_URL}assign-route-to-driver`,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  axios(config).then(
    (response) => {
      success();
    },
    (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        fail();
      }
    }
  );
};

export function fetchAllDrivers(handleSuccess, handleFailure) {
  const config = {
    method: "get",
    url: `${BASE_USER_URL}driver/`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  axios(config).then(
    (response) => {
      handleSuccess(desiredDriversShape(response.data));
    },
    (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    }
  );
}

const desiredDriverCodesShape = (data = {}) => ({
  internalCode: data.internal_driver_registration_code,
  externalCode: data.external_driver_registration_code,
});

export function fetchDriverCodes(handleSuccess, handleFailure) {
  const config = {
    method: "get",
    url: `${BASE_USER_URL}driver-registration-code`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  axios(config).then(
    (response) => {
      handleSuccess(desiredDriverCodesShape(response.data));
    },
    (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    }
  );
}

export function sendDriverInvite(
  email,
  isExternal,
  handleSuccess,
  handleFailure,
  companyId
) {
  const config = {
    method: "post",
    url: `${BASE_USER_URL}invite-driver`,
    data: {
      email,
      is_external_worker: isExternal,
      ...(companyId ? {Company_id: companyId} : {})
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  axios(config).then(
    () => {
      handleSuccess();
    },
    (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    }
  );
}

const desiredDeliveryFeeShape = (data = []) =>
  map(data, (obj) => ({
    driverFeeRate: obj.sales_order_driver_fee_rate,
    truckxiFeeRate: obj.sales_order_truckxi_fee_rate,
  }));

export function fetchDeliveryFee(handleSuccess, handleFailure) {
  const config = {
    method: "get",
    url: DISPATCH_DELIVERY_FEE_URL,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  axios(config).then(
    (response) => {
      handleSuccess(desiredDeliveryFeeShape(response.data));
    },
    (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    }
  );
}

export function saveDeliveryFees(
  driverFeeRate,
  truckxiFeeRate,
  handleSuccess,
  handleFailure
) {
  const config = {
    method: "put",
    url: DISPATCH_DELIVERY_FEE_URL,
    data: {
      sales_order_driver_fee_rate: driverFeeRate,
      sales_order_truckxi_fee_rate: truckxiFeeRate,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  axios(config).then(
    () => {
      handleSuccess();
    },
    (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    }
  );
}

export const fetchRoutesByCustomer = (id, success) => dispatch => {
  axios({
    method: "GET",
    url: `${DISPATCH_URL}routeslist_bycustomerid/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }).then(
    (response) => {
      success(response.data);
    },
    (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert('error fetch routes by customer.');
      }
    }
  );
}



// WEBPACK FOOTER //
// ./master/jsx/actions/dispatch_actions.jsx